<template>
	<div class="wnds_peom">
		<img class="wp_lficon" src="../../../static/img/wha_lficon_bgm.png" alt="">
		<div class="wp-peomlistbox">
			<div class="wp_top">
				<p>有时只是一首诗</p>
				<p>就能让我们找回对世界的初恋</p>
				<p></p>
				<p>「为你读诗」每天精选一诗、 一画、 一乐、 一文 ,<br>
				带你聆听世界上最干净美好的声音 ，找回生活的纯真年代。</p>
				<el-input   placeholder="期数/诗歌名/作者名/节目日期" v-model="searchtitle" @keyup.enter.native="searchTitle()" style="width:370px;padding-top:30px;z-index:999;" class="searchtitle">
         <i slot="prefix" class="el-input__icon el-icon-search" style="margin-top: 15px;"></i>
        </el-input>
         <p class="searchtxt" >注：按节目日期搜索可分别输入年月日数字，如2019、2019-09、2019-09-09</p>
        <!-- <p class="searchtxt">可在搜索框中按以下格式搜索： <br>
        1、直接输入节目期数、节目/诗歌标题、诗歌作者进行搜索 <br>
        例：输入135可搜索到135期节目，输入海子可搜索到全部海子的诗<br>
        2、输入特定格式的日期可搜索到该日期对应时间的全部节目<br>
        例：例入2019/2019-09/2019-09-09可搜索分别到2019年全年/2019<br>年9月/2019年9月9日的节目。</p> -->
			</div>

			<div id="wp-peomlist" class="wp-peomlist">
				<div class="wppl_slider" v-for="(item, index) in wpplSliderLast" :key="index" @click="goDetails(item.id)">
					<div class="wppl_slider_border"></div>
					<div class="wppls_box">
						<img :src="item.str_img_url" alt="">
						<i class="wppl_num">第{{item.n_periods_num}}期</i>
					</div>
					<p class="wppls_title">{{item.str_program_title}}</p>
					<p class="wppls_chtitle">{{item.str_peam_title}}</p>
					<p class="wppls_chtitle">读诗嘉宾：{{item.str_readpeam_user}}</p>
					<div class="wppl_line"></div>
				</div>
			</div>

			<div class="pemopagelist" v-if="wpplSliderLast.length >=9">
				<p>MORE</p>
				<div class="wpplm_pagebtn" @click="getMoreListFn">更多...</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'discover',
	data(){
		return{
			wpplSliderLast: [],
			currentNum: 0,
			rowCount: 0,
			searchtitle:''
		}
	},
	created(){
		this.$parent.activeIndex = 'discover'
		this.getwpplSliderLastFn(1, 9, "");
	},
	watch:{
		wpplSliderLast: function(){
			var _this = this;
			_this.$nextTick(function(){
				var data = _this.wpplSliderLast;
				if(data.length <2 ){
					 $("#wp-peomlist").css({
							"height": "1000px",
							'top':'335px',
							'left':'35%'
						})
						$(".wp_lficon").css('top','600px'); 
        }else {
          var boxHeight = Math.ceil((_this.rowCount*_this.currentNum)/3)*(539+54)+670;
					var totnum = Math.ceil((_this.rowCount*_this.currentNum)/3)
					 $("#wp-peomlist").css({
							// "height": "1000px",
							'top':'5px',
							'left':'0'
            })
          for (var i = 1; i<=totnum; i++){
            $("#wp-peomlist>div:nth-child("+(3*i-2)+")").css({
              "top": ((539+54)*(i-1)+30)+"px",
              "right": "0"
            })
            $("#wp-peomlist>div:nth-child("+(3*i-1)+")").css({
              "margin-left": "-183px",
              "top": ((539+54)*(i-1)+330)+"px",
              "left": "50%"
            })
            $("#wp-peomlist>div:nth-child("+(3*i)+")").css({
              "top": ((539+54)*(i-1)+460)+"px",
              "left": "0"
            })
          }
          // console.log(totnum)
          $("#wp-peomlist").height(boxHeight);
        }
			})
		},
		searchtitle(val){
			if(val == ""){
				 this.wpplSliderLast = []
				this.getwpplSliderLastFn(1, 9, '');
			}
		}
	},
	methods:{
		getwpplSliderLastFn(page, per, str){
			this.axios.post(
				process.env.API_HOST + '/programlisthome',
				this.$qs.stringify({"page": page, "per": per, "str": str})
			)
			.then(res => {
				if ( res.data.msg.rows.length >0 ){
				  // console.log(res.data.msg.rows)
					var getList = res.data.msg.rows;
					var newlist = this.wpplSliderLast.concat(getList);
					this.wpplSliderLast = newlist
          // console.log(this.wpplSliderLast)
					this.currentNum = res.data.msg.current;
					this.rowCount = res.data.msg.rowCount;
				}else {
          this.wpplSliderLast = []
          this.currentNum = res.data.msg.current;
          this.rowCount = res.data.msg.rowCount;
					$(".wpplm_pagebtn").html("暂无更多数据")
				}

			})
			.catch(error => {
				console.log(error);
				this.$toast("网络错误，不能访问");
			})
		},
		getMoreListFn(){
			var page = this.currentNum*1+1
			this.getwpplSliderLastFn(page, 9, "")
		},
		goDetails(id){
      this.$router.push({
        path:"/newsDetail?id="+id
      });
		},
		searchTitle(){
		  this.wpplSliderLast = []
			this.getwpplSliderLastFn(1, 9, this.searchtitle);
		}
	}
}
</script>
<style>
.el-input__inner{
  border-radius: 20px !important;
  height: 34px !important;
  line-height: 28px !important;
  border: 1px solid #999 !important;
  text-align: center;
  margin-right: 50px;
}
.el-input{
  margin-right: 20px;
}
.el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #999 !important;
}
/* .el-input__prefix {
    left: 11px;

    -webkit-transition: all .3s;
    transition: all .3s;
} */
.wnds_peom {
    position: relative;
		display: inline-table;
		width: 100%;
		background: #fff;
}
.wp_lficon {
    display: block;
    width: 92.55%;
    margin-left: -46.28%;
    position: absolute;
    top: 1460px;
    left: 50%;
}
.wp-peomlist, .wp-peomlistbox {
    overflow: hidden;
    width: 1140px;
    margin: 0 auto;
    position: relative;
}
.wp-peomlist {
    min-height: 500px;
    margin-top: 84px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
.wp_top {
    position: absolute;
    top: 84px;
    left: 0;
}
.wp_top p:first-child {
    font-size: 34px;
    line-height: 34px;
    margin-bottom: 26px;
    color: #658e31;
}
.wp_top p:nth-child(2) {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 50px;
    color: #658e31;
}
.wp_top p:nth-child(3) {
    /* font-size: 12px; */
    width: 80px;
    height: 6px;
    background: #9cc480;
    line-height: 12px;
    margin-bottom: 28px;
    /* color: #658e31; */
}
.wp_top p:nth-child(4) {
    text-indent: -.5em;
    font-size: 16px;
    line-height: 26px;
    color: #4c4c4c;
}
.searchtxt{
  margin-top: 6px;
  line-height: 20px;
  color: #9fa1a7;
}
.pemopagelist {
    position: absolute;
    bottom: 50px;
    left: 0;
}
.pemopagelist p {
    margin-left: -8px;
    font-size: 126px;
    line-height: 126px;
    color: #f1f1f4;
}
.wpplm_pagebtn {
    cursor: pointer;
    width: 170px;
    height: 62px;
    margin-top: -22px;
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 62px;
    background-color: #8ca764;
    position: relative;
    z-index: 111;
		top: 10px;
}
.wppl_slider:hover {
  -webkit-box-shadow: 0px 0px 50px -10px #cccccc;
  box-shadow: 0px 0px 50px -10px #cccccc;
}
.wppl_slider {
		cursor: pointer;
    width: 366px;
    font-family: myfont;
    position: absolute;
}
.wppl_slider_border {
    display: none;
    width: 152px;
    height: 5px;
    margin-left: -76px;
    background-color: #a7c07e;
    position: absolute;
    top: -3px;
    left: 50%;
    z-index: 10;
}
.wppl_slider:hover .wppl_slider_border {
  display: block;
}
.wppls_box {
    position: relative;
}
.wppls_box>img {
    width: 366px;
	height: 428px;
}
.wppl_num {
    width: 66px;
    height: 32px;
    color: #fff;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    border: 1px solid #fff;
    border-radius: 4px;
    position: absolute;
    top: 14px;
    right: 14px;
}
.wppls_title {
    margin-top: 30px;
		margin-left: 5px;
    font-size: 16px;
    line-height: 16px;
    color: #4c4c4c;
}
.wppls_chtitle {
    margin-top: 22px;
    margin-bottom: 28px;
    font-size: 12px;
		margin-left: 5px;
    line-height: 12px;
    color: #838383;
}
.wppl_line {
    width: 66px;
    height: 1px;
    background-color: #dcdcdc;
}

</style>





// WEBPACK FOOTER //
// src/components/page/Discover.vue